import { render, staticRenderFns } from "./requestToSend.vue?vue&type=template&id=5e70579e&lang=html&"
import script from "./requestToSend.vue?vue&type=script&lang=js&"
export * from "./requestToSend.vue?vue&type=script&lang=js&"
import style0 from "./requestToSend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "requestToSend.vue"
export default component.exports